const locale = {
    placeholder: '날짜 선택',
};
export default locale;
